import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'

// Global styles
import './assets/styles/main.css'

const app = createApp(App)

app.use(router)
app.use(store)
app.use(vuetify)

// Check authentication on app start
store.dispatch('auth/checkAuth')

app.mount('#app')
